module.exports = __webpack_public_path__ + "assets/img/35-m.df8a0ef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/35-m.jpg
// module id = YyD8
// module chunks = 0